module.exports = "/packs/images/svg/ireland/accessibility/poolside_facility~9e477bddbcdac7ea38c7fff1a62ac343.svg";